import styled from 'styled-components';

export const StyledThumbnail = styled.figure`
  margin: 0;
`;

export const ImagePlaceholder = styled.div<{ width: number; height: number }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: ${({ theme }) => theme.customColors.tertiary};
`;
